import { Schema, type SchemaInferInput, type SchemaInferOutput, acronym } from '@/shared/lib';

const UserInfoSchema = Schema.structures.pipe(
  Schema.structures.object({
    id: Schema.schemas.ID(),
    firstName: Schema.schemas.string(),
    lastName: Schema.schemas.string(),
    username: Schema.schemas.string(),
    avatar: Schema.structures.nullish(
      Schema.structures.object({
        url: Schema.schemas.string(),
      }),
    ),
  }),

  Schema.structures.transform((input) => ({
    ...input,
    fullName: `${input.firstName} ${input.lastName}`,
    acronym: acronym(input.firstName, input.lastName),
  })),
);

const UserPresenceInfoSchema = Schema.structures.pipe(
  Schema.structures.object({
    isOnline: Schema.structures.optional(Schema.schemas.boolean(), false),
    lastSeenAt: Schema.structures.nullish(Schema.schemas.dateFromString()),
  }),
);

type UserInfoSchemaType = SchemaInferOutput<typeof UserInfoSchema>;
type UserPresenceInfoSchemaType = SchemaInferOutput<typeof UserPresenceInfoSchema>;
type UserPresenceInfoInputSchemaType = SchemaInferInput<typeof UserPresenceInfoSchema>;

export {
  UserInfoSchema,
  UserPresenceInfoSchema,
  type UserInfoSchemaType,
  type UserPresenceInfoSchemaType,
  type UserPresenceInfoInputSchemaType,
};
